import React from 'react';
import styled from 'styled-components';

import { Link } from '@/types/serviceGroup';
import { SsoLink } from '../../../shared/Presentation/SsoLink';

type Props = {
  links: Link[];
  serviceGroupId: number;
};

export const AdminLinks: React.FC<Props> = ({ links, serviceGroupId }) => (
  <Wrapper>
    {links.map((link, i) => (
      <SsoLink key={i} link={link} serviceGroupId={serviceGroupId} />
    ))}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;
